import React, { useState } from "react";
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableRow, Checkbox, Radio, Paper } from "@mui/material";
import Lineinput from "../../../common/lineinput";
import { cellStyles, macAuthentication, otherEventConfigData, otherEventConfigRightData } from "./Constant";
import DropDownOA from "../../../common/dropDownOA";
import MpesaConfigurationModel from "./MpesaConfigurationModel";

const renderField = (type, fieldKey, style = {}, setEditSaveData, editSaveData,ratioValue, onMpesaConfigClick) => {
    const handleChange = (newValue) => {
        setEditSaveData(prev => ({
            ...prev,
            [fieldKey]: newValue
        }));
    };
    const fieldValue = editSaveData?.[fieldKey];

    switch (type) {
        case "checkbox":
            return (
                <Checkbox
                    checked={fieldValue === 1 || fieldValue === true}
                    onChange={(e) => handleChange(e.target.checked ? 1 : 0)}
                    sx={{
                        fontSize: '12px',
                        backgroundColor: 'transparent !important',
                        height: '36px',
                        verticalAlign: 'middle',
                        ...style,
                    }}
                />
            );

        case "radio":
            return (
                <Radio
                    checked={fieldValue === ratioValue}
                    onChange={() => handleChange(ratioValue)} // assumes selecting this radio sets the value
                    name={fieldKey}
                    sx={{ ...style}}
                />
            );

        case "text":
            return (
                <Box className="inputBox">
                    <div
                        className={'input--wrapper'}
                        style={{
                            width: '100%',
                            marginBottom:'0px'
                        }}
                    >
                        <Lineinput
                            value={fieldValue || ''}
                            onChange={(e) => handleChange(e.target.value)}
                            disabled={fieldKey === 'isDisable'}
                        />
                    </div>
                </Box>
            );
        case "DropDown":
            return (
                <DropDownOA
                    label={'Status'}
                    id={'status'}
                    data={macAuthentication || []}
                    defaultvalue={editSaveData.macDrop}
                    // value={editSaveData.macDrop}
                    onSelect={(val) => {
                        setEditSaveData((prev) => ({
                            ...prev,
                            WebCargoEnabledMode: val.id,
                        }));
                    }}
                    noCross={true}
                    idKey={`id`}
                    dataKey={`name`}
                    // minWidth="350px"
                    listWidth={'300px'}
                    nextId={'loadBtn'}
                />
            );
        case "button":
            return (
                <Button
                    id="mpesaConfiguration"
                    style={{ margin: '0', height: "34px", width: '100%', fontSize: '12px' }}
                    className="btn add-btn"
                    variant="contained"
                    color="error"
                    onClick={onMpesaConfigClick}
                >
                    MPESA CONFIG
                </Button>
            );

        default:
            return null;
    }
};
const OtherEventsConfig = (props) => {
    const {
        setEditSaveData,
        editSaveData,
        loginData,
        selEditLuggageSetting,
        companyMpesaSettingData,
        handleSaveSetting,
        refreshCargoSettingData,
    } = props
    const [openMpesaModel, setOpenMpesaModel] = useState(false)
    const handleMpesaConfigClick = async () => {
        await refreshCargoSettingData?.()
        setOpenMpesaModel(true)
    }
    return (
        <>
            <Box sx={{ width: "100%" }}>
                <TableContainer component={Paper} style={{ display: 'flex', overflow: 'visible' }} className="scrollBlue" >
                    <Table size="small" style={{ width: '50%', borderRight: '1px solid #d9d9d9' }}>
                        <TableBody>
                            {otherEventConfigData.map((section, sectionIdx) => (
                                <React.Fragment key={`section-${sectionIdx}`}>
                                    <TableRow>
                                        <TableCell colSpan={4} sx={{ background: "#DAEDFE", fontWeight: '600', padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                            {section.section}
                                        </TableCell>
                                    </TableRow>

                                    {section.rows.map((row, rowIdx) => (
                                        <TableRow key={`row-${sectionIdx}-${rowIdx}`}>
                                            {/* Left Side */}
                                            <TableCell style={{ ...cellStyles,width: '25%',padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto',fontWeight:row.leftLabel==="CHALLAN TYPE"?'bold':'500' }}>
                                                {row.leftLabel}
                                            </TableCell>
                                            <TableCell sx={{ ...cellStyles,textAlign: "center", ...row.leftStyle, width: "25%" }}>
                                                {renderField(row.leftType, row.leftValue, row.leftStyle, setEditSaveData, editSaveData,row.leftRadioValue, handleMpesaConfigClick)}
                                            </TableCell>
                                            {/* Right Side */}
                                            <TableCell sx={{ ...cellStyles,width: "25%",padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                                {row.rightLabel}
                                            </TableCell>
                                            <TableCell sx={{ ...cellStyles,textAlign: "center", ...row.rightStyle, width: "25%" }}>
                                                {renderField(row.rightType, row.rightValue, row.rightStyle, setEditSaveData, editSaveData,row.rightRadioValue, handleMpesaConfigClick)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                    <Table size="small" style={{ width: '50%' }}>
                        <TableBody>
                            {otherEventConfigRightData.map((section, sectionIdx) => (
                                <React.Fragment key={`section-${sectionIdx}`}>
                                    <TableRow>
                                        <TableCell colSpan={4} sx={{ background: "#DAEDFE", fontWeight: '600', padding: '7px 12px', fontSize: '12px', color: '#444444', fontFamily: 'Roboto' }}>
                                            {section.section}
                                        </TableCell>
                                    </TableRow>

                                    {section.rows.map((row, rowIdx) => (
                                        <TableRow key={`row-${sectionIdx}-${rowIdx}`}>
                                            {/* Left Side */}
                                            <TableCell sx={{ ...cellStyles,width: '25%',whiteSpace:'normal' }}>
                                                {row.leftLabel}
                                            </TableCell>
                                            <TableCell sx={{width: '25%', textAlign: "center", ...row.leftStyle }}>
                                                {renderField(row.leftType, row.leftValue, row.leftStyle, setEditSaveData, editSaveData,row.leftRadioValue, handleMpesaConfigClick)}
                                            </TableCell>
                                            {/* Right Side */}
                                            <TableCell sx={{ ...cellStyles,width: '25%',whiteSpace:'normal' }}>
                                                {row.rightLabel}
                                            </TableCell>
                                            <TableCell sx={{ width: '25%',textAlign: "center", ...row.rightStyle }}>
                                                {renderField(row.rightType, row.rightValue, row.rightStyle, setEditSaveData, editSaveData,row.rightRadioValue, handleMpesaConfigClick)}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </React.Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            {openMpesaModel ? (
                <MpesaConfigurationModel
                    updateModal={() => setOpenMpesaModel(false)}
                    loginData={loginData}
                    selEditLuggageSetting={selEditLuggageSetting}
                    companyMpesaSettingData={companyMpesaSettingData}
                    handleSaveSetting={handleSaveSetting}
                />
            ) : null}
        </>
    )
}

export default OtherEventsConfig
